import React from "react";

const CustomRadioInput = ({
  label,
  name,
  checked,
  onChange,
  labelStyles,
  inputStyles,
  value,
  required = false,
  defaultValue,
  type,
  defaultChecked,
  id,
}) => {
  return (
    <div className="form-check">
      <label
        style={{ ...labelStyles }}
        htmlFor={id}
        className="form-check-label"
      >
        <input
          className="form-check-input"
          required={required}
          name={name}
          type={type}
          value={value}
          id={id}
          defaultValue={defaultValue}
          defaultChecked={defaultChecked}
          checked={checked}
          onChange={onChange}
          style={{ ...inputStyles }}
        />
        {label} <i className="input-helper" />
      </label>
    </div>
  );
};

export default CustomRadioInput;
